const stripTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const defaults = {
  userServiceUrl: 'https://refinery-user-service-hvg0g8ceddefaseb.australiasoutheast-01.azurewebsites.net',
  noteServiceUrl: 'https://refinery-note-service-e3btdjbccsbdb5af.australiasoutheast-01.azurewebsites.net',
  graphServiceUrl: 'https://refinery-graph-service-fed6gvbmgzdvbrf0.australiasoutheast-01.azurewebsites.net',
};

export const USER_SERVICE_URL = stripTrailingSlash(
  process.env.REACT_APP_USER_SERVICE_URL || defaults.userServiceUrl
);

export const NOTE_SERVICE_URL = stripTrailingSlash(
  process.env.REACT_APP_NOTE_SERVICE_URL || defaults.noteServiceUrl
);

export const GRAPH_SERVICE_URL = stripTrailingSlash(
  process.env.REACT_APP_GRAPH_SERVICE_URL || defaults.graphServiceUrl
);

export const API_ENDPOINTS = {
  register: `${USER_SERVICE_URL}/register`,
  login: `${USER_SERVICE_URL}/login`,
  notes: `${NOTE_SERVICE_URL}/notes`,
  note: `${NOTE_SERVICE_URL}/note`,
  noteSummaries: `${NOTE_SERVICE_URL}/note_summaries`,
  graphData: `${GRAPH_SERVICE_URL}/graph_data`,
  graphDataByNote: `${GRAPH_SERVICE_URL}/graph_data_by_note`,
  graphDataBySearch: `${GRAPH_SERVICE_URL}/graph_data_by_search`,
};
